module.exports = __webpack_public_path__ + "static/img/team-bg.16ec647.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team-bg.png
// module id = nW+u
// module chunks = 36